import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetTenderListMutationRequest, GetTenderListMutationResponse, GetTenderList400, GetTenderList401, GetTenderList403, GetTenderList422, GetTenderList429, GetTenderList500 } from "../types/GetTenderList";

/**
 * @link /api/purchase-tenders/private/v1/tenders
 */

export function useGetTenderList <TData = GetTenderListMutationResponse, TError = GetTenderList400 | GetTenderList401 | GetTenderList403 | GetTenderList422 | GetTenderList429 | GetTenderList500, TVariables = GetTenderListMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/private/v1/tenders`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
